import { useSubscriptions } from '../hooks/useSubscriptions';
import { useAuth } from '../hooks/useAuth';
import AppLayout from '../components/layout/AppLayout';
import ServiceCard from '../components/services/ServiceCard';
import SuspendedBanner from '../components/services/SuspendedBanner';
import Spinner from '../components/common/Spinner';

export default function ServicesPage() {
  const { data: subscriptions, isLoading, error } = useSubscriptions();
  const { user } = useAuth();

  // Billing role has read-only access - cannot view details or open controller
  const canViewDetails = user?.role !== 'billing';
  const canOpenController = user?.role !== 'billing';

  const activeSubscriptions = subscriptions?.filter(
    (s) => s.status !== 'archived' && s.status !== 'suspended'
  );

  return (
    <AppLayout>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Your Services</h1>
        <p className="text-gray-600 mt-1">
          Manage your UniFi and UISP services
        </p>
      </div>

      {subscriptions && <SuspendedBanner subscriptions={subscriptions} />}

      {isLoading && (
        <div className="flex justify-center py-12">
          <Spinner size="lg" />
        </div>
      )}

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">
          Failed to load subscriptions. Please try again later.
        </div>
      )}

      {activeSubscriptions && activeSubscriptions.length === 0 && !subscriptions?.some(
        (s) => s.status === 'suspended' || s.status === 'archived'
      ) && (
        <div className="text-center py-12">
          <p className="text-gray-500">No active subscriptions found.</p>
        </div>
      )}

      {activeSubscriptions && activeSubscriptions.length > 0 && (
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {activeSubscriptions.map((subscription) => (
            <ServiceCard
              key={subscription.id}
              subscription={subscription}
              showViewDetails={canViewDetails}
              showOpenController={canOpenController}
            />
          ))}
        </div>
      )}
    </AppLayout>
  );
}
